module.exports = __webpack_public_path__ + "img/alianza-popular.a149a6e2.png";